module.exports = __webpack_public_path__ + "static/about-team1-0c2156b382628baecff4273bc80f4d9d.jpg";